import { createElement } from "./vdom";
import { BaseComponent } from "./vdom-util";
import { ToolbarModel, ToolbarWidget } from "./toolbar-struct";
import { ToolbarSection, ToolbarContent } from "./ToolbarSection";
import React from "react";
import styled from "styled-components";
import i18Service from "../../../i18n";

export interface ToolbarProps extends ToolbarContent {
  extraClassName: string; // wish this could be array, but easier for pureness
  model: ToolbarModel;
}

export class Toolbar extends BaseComponent<ToolbarProps> {
  render() {
    let { model, extraClassName } = this.props;
    let forceLtr = false;
    let startContent;
    let endContent;
    let centerContent = model.center;

    if (model.left) {
      forceLtr = true;
      startContent = model.left;
    } else {
      startContent = model.start;
    }

    if (model.right) {
      forceLtr = true;
      endContent = model.right;
    } else {
      endContent = model.end;
    }

    let classNames = [
      //extraClassName || "",
      "fc-toolbar",
      forceLtr ? "fc-toolbar-ltr" : "",
    ];

    return (
      <ToolbarHeader>
        {this.renderSection("start", startContent || [])}
        {this.renderSection("center", centerContent || [])}
        {this.renderSection("end", endContent || [])}
      </ToolbarHeader>
    );

    // return (
    //   <div className={classNames.join(" ")}>
    //     {this.renderSection("start", startContent || [])}
    //     {this.renderSection("center", centerContent || [])}
    //     {this.renderSection("end", endContent || [])}
    //   </div>
    // );
  }

  renderSection(key: string, widgetGroups: ToolbarWidget[][]) {
    let { props } = this;
    // HACK =====================
    // props.title => August 2021

    const MONTHS = [
      "Jennuary",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const translatedTitle = props.title ? props.title.split(" ") : [];
    let title = props.title;
    if (translatedTitle.length === 2) {
      title = `${i18Service.t(
        `months.${MONTHS.findIndex((m) => m === translatedTitle[0])}`
      )} ${translatedTitle[1]}`;
    }

    return (
      <ToolbarSection
        key={key}
        widgetGroups={widgetGroups}
        title={title}
        activeButton={props.activeButton}
        isTodayEnabled={props.isTodayEnabled}
        isPrevEnabled={props.isPrevEnabled}
        isNextEnabled={props.isNextEnabled}
      />
    );
  }
}

// HACK ========================

const ToolbarHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  justify-content: space-between;
`;
